import { z } from 'zod'
import { FREE_SCAN_ENTRIES } from '@/lib/tools/free-scan-page-event'

export const visScanSchema = z.object({
  domain: z
    .string()
    .min(1)
    .max(253)
    .transform((v) =>
      v
        .replace(/^https?:\/\//i, '')
        .replace(/\/.*$/, '')
        .toLowerCase()
        .trim()
    )
    .refine((v) => /^[a-z0-9.-]+\.[a-z]{2,}$/.test(v), { message: 'Invalid domain' }),
})

export type VisScanInput = z.infer<typeof visScanSchema>

/**
 * The longest Turnstile token Cloudflare documents (2048 characters). One cap for every free-scan
 * route that carries a token, so the scan start and the email request cannot drift apart.
 */
export const TURNSTILE_TOKEN_MAX_LENGTH = 2048

/**
 * The scan route's body: the domain, the Turnstile token its start must carry (AC-10) and the
 * `entry` its funnel events report (AC-11). A body with no `entry` is the result page's.
 */
export const visScanRequestSchema = visScanSchema.extend({
  turnstileToken: z.string().max(TURNSTILE_TOKEN_MAX_LENGTH).optional(),
  entry: z.enum(FREE_SCAN_ENTRIES).default('result'),
})
